import { DocumentItemType } from "../components/DriverDocuments/types";

export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const formatFileSize = (size: number) => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
};

type FileObject = {
  id: string;
  name: string;
  size: number;
  type: string;
};

export const prepareDocuments = (
  allDocuments: DocumentItemType[],
  approvedPendingDocuments: DocumentItemType[]
): DocumentItemType[] => {
  const approvedPendingNames = new Set(
    approvedPendingDocuments.map((file) => file.name)
  );

  return allDocuments.filter((file) => !approvedPendingNames.has(file.name));
};
